/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { PREFIX } from '../constants';
import { FETCH_SEASONS, RESET_SEASONS } from '../constants/actions';
import {
    asyncDefaults,
    makeAsyncReducer,
    makeAsyncResetReducer,
    mergeReducers,
} from '../utils/async_utils';
import { RootState } from '../../dev/store';
import type { SeasonData } from '../../types/permit';

const fetchSeasons = makeAsyncReducer(FETCH_SEASONS);
const resetSeasons = makeAsyncResetReducer(RESET_SEASONS, []);

const seasons = mergeReducers(asyncDefaults({}), PREFIX, fetchSeasons, resetSeasons);

export default seasons;

export const selectors = {
    getSeasons: (state: RootState) =>
        state.treePermit?.seasons?.data as Record<string, SeasonData>,
};
